import { render } from "./TeamBasketball.vue?vue&type=template&id=a54eb7a0&scoped=true&ts=true"
import script from "./TeamBasketball.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamBasketball.vue?vue&type=script&setup=true&lang=ts"

import "./TeamBasketball.vue?vue&type=style&index=0&id=a54eb7a0&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a54eb7a0"],['__file',"src/components/player/TeamBasketball.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a54eb7a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a54eb7a0', __exports__)) {
    console.log('reload')
    api.reload('a54eb7a0', __exports__)
  }
  
  module.hot.accept("./TeamBasketball.vue?vue&type=template&id=a54eb7a0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a54eb7a0', render)
  })

}


export default __exports__